import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { applyRuntimeConfig } from './app/runtime-config';
import { applyStoredTheme } from './app/service/theme';

applyRuntimeConfig()
  .then(() => {
    applyStoredTheme();
    return bootstrapApplication(App, appConfig);
  })
  .catch((err) => console.error(err));
